import React, { useState, useRef, useEffect } from "react";
import ChevronRightIcon from "../assets/icons/circle-chevron-right.svg";
import ChevronDownIcon from "../assets/icons/circle-chevron-down.svg";
import "../styles/components/usefull_info_card.css";

const UsefullInfoCard = ({ date, title, description }) => {
  const [isOpen, setIsOpen] = useState(false);

  const bodyRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      if (isOpen && bodyRef.current) {
        bodyRef.current.style.maxHeight = bodyRef.current.scrollHeight + "px";
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isOpen]);

  const toggleCard = () => {
    if (!bodyRef.current) return;

    if (!isOpen) {
      bodyRef.current.style.maxHeight = bodyRef.current.scrollHeight + "px";
      setIsOpen(true);
    } else {
      bodyRef.current.style.maxHeight = "0px";
      setIsOpen(false);
    }
  };

  return (
    <div className="usefull-info-card">
      <div className="card-header">
        <div className="card-header-text">
          <div className="card-date">{date}</div>
          <div className="card-title">{title}</div>
        </div>
        <button className="toggle-btn" onClick={toggleCard}>
          <img
            src={isOpen ? ChevronDownIcon : ChevronRightIcon}
            alt="toggle"
          />
        </button>
      </div>
      <div className="card-body" ref={bodyRef}>
        <p className="description-text">{description}</p>
      </div>
    </div>
  );
};

export default UsefullInfoCard;
